import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";

import { store } from 'react-notifications-component'; 

import api from '../../services/api';
import { login } from "../../services/auth";

import axios from 'axios';

import InputV3 from '../../components/input/novo/input_v3';
import ModalTermos from '../../components/modal/modalTermos';
import ModalPoliticas from '../../components/modal/modalPoliticas';

import SetaCinzaDireita from '../../assets/icons/icon-right-gray.svg';
import SetaCinzaEsquerda from '../../assets/icon-left-gray.png';

import SetaBranca from '../../assets/icons/icon-right-white.svg';
import LogoBranca from '../../assets/logo-agroreceita-branco.svg';
import ImageRegisterCompleted from '../../assets/undraw-register-completed.png';

import * as S from './complete-registration-styles';
import { theme } from '../../styles/theme';
import { Auxiliar, BodyG, BodyM, H3, TaglineM } from '../../styles/stylesTypography';
import { isTotvs } from '../../services/globalFunctions';

import maintainUtm from '../../services/maintainUtm/index'

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const NovoCadastroCompleto = ({ location, history, ...props }) => {
    const [width, setWidth] = useState(window.innerWidth);

    const [campaign, setCampaign] = useState(null);

    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');

    const [empresa, setEmpresa] = useState('');
    const [hasEmpresaError, setHasEmpresaError] = useState(false);
    const [empresaError, setEmpresaError] = useState('');

    const [workspace, setWorkspace] = useState({ value: 0, label: '' });
    const [workspaces, setWorkspaces] = useState([]);

    const [cargo, setCargo] = useState({ value: 0, label: '' }); 
    const [cargos, setCargos] = useState([]);

    const [telefone, setTelefone] = useState('');
    const [hasTelefoneError, setHasTelefoneError] = useState(false);
    const [telefoneError, setTelefoneError] = useState('');

    const [quantidadeReceitas, setQuantidadeReceitas] = useState({ value: '', label: '' });
    const [obs, setObs] = useState(''); 
   
    const [utmParams, setUtmParams] = useState({}); 
    const [hasUtmSaved, setHasUtmSaved] = useState(false);
    const [loading, setLoading] = useState(false);

    const [showTermos, setShowTermos] = useState(false);
    const [showPolitica, setShowPolitica] = useState(false);

    localStorage.setItem('@inscription_user_email', email)

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

    const getWorkspaces = async () => {
        try {
            const response = await api.get('/workspaces');

            if (response.data.data) {
                setWorkspaces(response.data.data);
            }

        } catch (error) {}
    };

    const getJobsCategories = async () => {
        try {
            const response = await api.get('/jobs/categories');

            if (response.data.data) {
                setCargos(response.data.data);
            }
        } catch (error) {}
    };

    const getCampaign = async () => {
        try {
            const response = await api.get('/campaigns');
            const data = Array.isArray(response.data?.data)
                ? response.data.data
                : Array.isArray(response.data)
                    ? response.data
                    : [];

            const activeCampaign = data.find((c) => c?.ativo === 1) || null;
            setCampaign(activeCampaign);
        } catch {
            setCampaign(null);
        }
    };

    useEffect(() => {
        getWorkspaces();
        getJobsCategories();
        getCampaign();
    }, []);

    const clickPolitica = () => {
        setShowPolitica(true);
    }

    const clickTermos = () => {
        setShowTermos(true);
    }

    useEffect(() => {
        if (location.state) {
            const { nome, email, utmParams, obs } = location.state;
            setNome(nome);
            setEmail(email);

            if (!hasUtmSaved) {
                setUtmParams(utmParams); 
                setHasUtmSaved(true);
            }
            setObs(obs)
        }
    }, [location.state]);

    const handleEmpresaChange = (e) => {
        const newEmpresa = e.target.value;
        setEmpresa(newEmpresa);

        setHasEmpresaError(false);
        setEmpresaError("");
    };

    const handleEmpresaBlur = () => {
      
        if (empresa.length === 4) {
          const FirstCaractere = empresa[0].toLowerCase(); 
          const LastCaractere = empresa[empresa.length - 1].toLowerCase();
      
          if (FirstCaractere === LastCaractere) {
            setHasEmpresaError(true);
            setEmpresaError("O nome da empresa não pode começar e terminar com o mesmo caractere.");
            return; 
          }
        }
      
        if (empresa.length <= 3) {
          setHasEmpresaError(true);
          setEmpresaError("A empresa deve conter mais de 3 caracteres.");
        }
      };

    const handleTelefoneChange = (e) => {
        const newTelefone = e.target.value;
        setTelefone(newTelefone);

        setHasTelefoneError(false);
        setTelefoneError("");
    };
    
    const handleTelefoneBlur = () => {
        if (telefone.length < 13) {
            setHasTelefoneError(true);
            setTelefoneError("Número inválido");
        }
    };

    const isFormValid = () => {
        const trimmedEmpresa = empresa.trim();
    
        const endsWithSpaceAndNothingAfter = /^\S+\s$/.test(empresa);
    
        const isEmpresaValid = trimmedEmpresa !== '' && 
            trimmedEmpresa.length >= 4 && 
            (trimmedEmpresa.split(' ').length >= 2 ||
            trimmedEmpresa.length > 4 ||
            trimmedEmpresa[0].toLowerCase() !== trimmedEmpresa[trimmedEmpresa.length - 1].toLowerCase()); 
    
        const isWorkspaceValid = workspace.value !== 0; 
        const isCargoValid = cargo.value !== 0; 
        const isTelefoneValid = telefone.trim() !== '' && (telefone.length === 13 || telefone.length === 14);
        const isQuantidadeReceitasValid = quantidadeReceitas.value !== '';
    
        return isEmpresaValid && isWorkspaceValid && isCargoValid && isTelefoneValid && isQuantidadeReceitasValid;
    };

    const handleGoToBack = () => {
        if (width <= 768) {
            history.push({
                pathname: "/cadastro-email",
                search: maintainUtm(),
                state: { nome, email, utmParams, obs, emailValidationForm: true }
            });
        } else {
            history.push({
                pathname: "/cadastro",
                search: maintainUtm(),
                state: { nome, email, utmParams, obs, emailValidationForm: true }
            });
        }
    }

    const signIn = async (email, tipo) => {
        try {
            try {
                const headers = {
                    'apiKey': process.env.REACT_APP_API_KEY
                }

                axios.post(`${process.env.REACT_APP_API_HOST}/login`, { username: email, password: null, loginSocial: 1, type: tipo !== null && tipo }, { headers })
                    .then(response => {
                        if (response) {
                            login(response.data.data, 'login');

                            let isLogged = localStorage.getItem('@logged');

                            if ((isLogged == false || isLogged == 'false') && (localStorage.getItem('@open') == false || localStorage.getItem('@open') == 'false')) {
                                localStorage.setItem("@open", "true");
                                if (isTotvs() && response.data.data.user.agro_permission_id === 4) {
                                    window.location = '/integracao-webhook'; 
                                } else {
                                    window.location = '/apresentacao';
                                }
                            } else {
                                if (isTotvs() && response.data.data.user.agro_permission_id === 4) {
                                    window.location = "/usuarios";
                                } else {
                                    window.location = "/";
                                }
                            }
                        }
                    }).catch(error => {
                        localStorage.removeItem('@agroreceita_google_email');
                        localStorage.removeItem('@agroreceita_google_user');
                        localStorage.removeItem('@agroreceita_google_user_profile');
                    });
            } catch (err) {
                localStorage.removeItem('@agroreceita_google_email');
                localStorage.removeItem('@agroreceita_google_user');
                localStorage.removeItem('@agroreceita_google_user_profile');
            }
        } catch (err) {
            localStorage.removeItem('@agroreceita_google_email');
            localStorage.removeItem('@agroreceita_google_user');
            localStorage.removeItem('@agroreceita_google_user_profile');
        }
    }

    const handleContinuarClick = async () => {
        setLoading(true); 

        if (isFormValid()) {
            // Normaliza utmParams e garante utm_term como string
            const normalizedUtmParams = {
                ...utmParams,
                utm_id: String(utmParams?.utm_id ?? '0'),
                utm_source: typeof utmParams?.utm_source === 'string' ? utmParams.utm_source : 'orgânico',
                utm_medium: typeof utmParams?.utm_medium === 'string' ? utmParams.utm_medium : 'orgânico',
                utm_campaign: typeof utmParams?.utm_campaign === 'string' ? utmParams.utm_campaign : 'orgânico',
                utm_term: typeof utmParams?.utm_term === 'string' ? utmParams.utm_term : '',
                button: typeof utmParams?.button === 'string' ? utmParams.button : '0',
                device_id: typeof utmParams?.device_id === 'string' ? utmParams.device_id : '',
            };

            let payload = {};

            if (obs === 'google') {
                payload = {
                    id: "0",
                    email: email,
                    name: nome,
                    nome_fantasia: empresa.trim(),
                    telefone,
                    cargo: cargo.label, 
                    cargo_id: String(cargo.value),
                    workspace: workspace.label,
                    workspace_id: String(workspace.value),
                    receitas: quantidadeReceitas.value,
                    utmParams: normalizedUtmParams,
                    obs: obs
                };
            } else {
                payload = {
                    email: email,
                    nome: nome,
                    nome_fantasia: empresa.trim(),
                    telefone,
                    cargo: cargo.label, 
                    cargo_id: cargo.value,
                    workspace: workspace.label,
                    workspace_id: String(workspace.value),
                    receitas: quantidadeReceitas.value,
                    utmParams: normalizedUtmParams,
                    obs: obs
                };
            }

            try {
                if (obs === 'google') {
                     const response = await api.post(`/cadastro/teste/google`, payload);

                    if (response.data) {
                        localStorage.setItem("@agroreceita_email_sub", payload.email);
                        localStorage.setItem("gtm_data", JSON.stringify({
                            nome,
                            email,
                            telefone
                        }));

                        signIn(email, 'google');
                    }
                } else {
                     const response = await api.post(`cadastro/teste`, payload);

                    if (response.data) {
                        localStorage.setItem("@agroreceita_email_sub", payload.email);
                        localStorage.setItem("gtm_data", JSON.stringify({
                            nome,
                            email,
                            telefone,
                        }));

                        history.push({
                            pathname: "/cadastro/sucesso",
                            search: maintainUtm(),
                        });
                    }
                }
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        const exit = localStorage.getItem('@exit');
        
        if (exit === 'false') {
            localStorage.clear();
            window.location.reload();
        }
    }, []);

    const currentDate = new Date();
    const baseTarget = campaign?.data_final ? new Date(campaign.data_final) : null;
    const targetDate = baseTarget ? new Date(baseTarget.getTime() + 3 * 60 * 60 * 1000) : null;

    const hasActiveCampaignLateral = Boolean(
        campaign?.ativo === 1 &&
        (!targetDate || currentDate <= targetDate) &&
        campaign?.imagem_lateral &&
        campaign?.texto_lateral
    );

    const renderMultilineText = (text) => {
        const parts = String(text ?? '').split(/\r?\n/);
        return (
            <>
                {parts.map((part, idx) => (
                    <React.Fragment key={`${idx}-${part}`}>
                        {part}
                        {idx < parts.length - 1 ? <br /> : null}
                    </React.Fragment>
                ))}
            </>
        );
    };

    const renderHeadingText = () => {
        if (hasActiveCampaignLateral) {
            return renderMultilineText(campaign.texto_lateral);
        }

        return (
            <>
                Quase lá! Estamos<br/> finalizando o seu cadastro...
            </>
        );
    };

    const renderParagraphText = () => {
        if (width <= 767) {
            return  (
                <>
                  Preencha as últimas informações<br/>  para iniciar seu teste grátis!
                </>
            );
        } else {
            return  (
                <>
                  Preencha as últimas informações para iniciar seu<br/> teste grátis!
                </>
            );
        }
    };

    const renderImage = () => {
        if (width <= 767) {
            return '';
        }

        if (hasActiveCampaignLateral) {
            return campaign.imagem_lateral;
        }

        return ImageRegisterCompleted;
    };

    const renderContainerImage = () => {
        if (width <= 767) {
            return '';
        } else {
            return (
                    <S.ContainerImageCompleted>
                        <img
                            src={renderImage()}
                            alt=''
                            style={{
                                maxWidth: '280px',
                                maxHeight: '240px'
                            }}
                        />
                    </S.ContainerImageCompleted>
            );
        }
    };

    const renderFormMobile = () => {
        if (width <= 767) {
            return (
                <S.Form id='form-cadastro'>
                    <div style={{display: 'none'}}>
                        <InputV3
                            id="nome"
                            value={nome}
                            label="Nome"
                            marginBottom='0px'
                        />

                        <InputV3
                            id="email"
                            value={email}
                            label="E-mail"
                            marginBottom='0px'
                        />
                    </div>
                    
                    <BodyM color={theme.colors.gray.Cinza_2} fontWeight={700} id="email">{email}</BodyM>

                    <S.ContainerInputs>
                        <InputV3
                            id="empresa"
                            type="text"
                            label="Empresa"
                            floatingLabelWithAsterisk="Empresa"
                            placeholder=""
                            value={empresa}
                            onChange={handleEmpresaChange}
                            hasError={hasEmpresaError}
                            onBlur={handleEmpresaBlur}
                            errorInfo={empresaError}
                        />

                        <InputV3
                            id="workspace_id"
                            type="select"
                            label="Local de trabalho"
                            typeValueSelect="number"
                            floatingLabelWithAsterisk="Local de trabalho"
                            placeholder="Selecione um local de trabalho"
                            value={workspace.label} 
                            onChange={(selectedOption) => {
                                setWorkspace({
                                    value: selectedOption.value,
                                    label: selectedOption.label
                                });
                            }}
                            options={workspaces.map(workspace => ({ 
                                value: workspace.value, 
                                label: workspace.label }))}
                            hasError={false}
                            errorInfo={''}
                        />

                        <InputV3
                            id="cargo"
                            type="select"
                            label="Cargo"
                            typeValueSelect="number"
                            floatingLabelWithAsterisk="Cargo"
                            placeholder="Selecione um cargo"
                            value={cargo.label}
                            onChange={(selectedOption) => {
                                setCargo({
                                    value: selectedOption.value,
                                    label: selectedOption.label
                                })
                            }}
                            options={cargos.map(cargo => ({ 
                                value: cargo.value, 
                                label: cargo.label }))}
                            hasError={false}
                            errorInfo={''}
                        />

                        <InputV3
                            id="telefone"
                            type="telefone/celular"
                            label="Telefone/celular"
                            floatingLabelWithAsterisk="Telefone/Celular"
                            placeholder=""
                            value={telefone}
                            onChange={handleTelefoneChange}
                            hasError={hasTelefoneError}
                            onBlur={handleTelefoneBlur}
                            errorInfo={telefoneError}
                        />

                        <InputV3
                            id="receitas"
                            type="select"
                            label="Quantas receitas você emite por mês?"
                            typeValueSelect="string"
                            floatingLabelWithAsterisk="Quantas receitas você emite por mês?"
                            placeholder="Selecione a quantidade de receitas"
                            value={quantidadeReceitas.label}
                            onChange={(selectedOption) => {
                                setQuantidadeReceitas({
                                    value: selectedOption.value,
                                    label: selectedOption.label
                                });
                            }}
                            options={[
                                { value: "não", label: "Não emito receitas" },
                                { value: "1-10", label: "1 a 10" },
                                { value: "11-30", label: "11 a 30" },
                                { value: "31-50", label: "31 a 50" },
                                { value: "51-100", label: "51 a 100" },
                                { value: "+100", label: "Mais de 100" },
                            ]}
                            hasError={false}
                            errorInfo={''}
                        />
                    </S.ContainerInputs>

                    <S.ContainerButtonsAndTerms>
                        <S.ContainerButtons>
                            <S.ToGoBackButton
                                    type="button"
                                    onClick={handleGoToBack}
                                >
                                        <img src={SetaCinzaEsquerda} alt='Seta para esquerda ' />

                                        <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>Voltar</TaglineM>
                            </S.ToGoBackButton>

                            <S.SubmitButton
                                type="submit"
                                disabled={!isFormValid() || loading}
                                onClick={handleContinuarClick}
                            >
                                {loading ? (
                                    <S.Loading/>
                                ) : (
                                    <>
                                        <TaglineM fontWeight={800}>Entrar</TaglineM>

                                        <img src={isFormValid() ? SetaBranca : SetaCinzaDireita} alt='Seta para direita' />
                                    </>
                                )}
                            </S.SubmitButton>
                        </S.ContainerButtons>

                        <Auxiliar color={theme.colors.gray.Cinza_7} fontWeight={700}>
                            Ao continuar você concorda com a <br />
                            <label onClick={() => clickPolitica()}>Política de Privacidade </label>
                            e
                            <label onClick={() => clickTermos()}> Termos de Uso.</label>
                        </Auxiliar>
                    </S.ContainerButtonsAndTerms>
                </S.Form>
            );
        } else {
            return (
                <S.Form id='form-cadastro'>
                    <div style={{display: 'none'}}>
                        <InputV3
                            id="nome"
                            value={nome}
                            label="Nome"
                            marginBottom='0px'
                        />

                        <InputV3
                            id="email"
                            value={email}
                            label="E-mail"
                            marginBottom='0px'
                        />
                    </div>

                    <BodyM color={theme.colors.gray.Cinza_2} fontWeight={700} id="email">{email}</BodyM>

                    <S.ContainerInputs>
                        <InputV3
                            id="empresa"
                            type="text"
                            label="Empresa"
                            floatingLabelWithAsterisk="Empresa"
                            placeholder=""
                            value={empresa}
                            onChange={handleEmpresaChange}
                            hasError={hasEmpresaError}
                            onBlur={handleEmpresaBlur}
                            errorInfo={empresaError}
                        />

                        <InputV3
                            id="workspace_id"
                            type='select'
                            label="Local de trabalho"
                            typeValueSelect='number'
                            floatingLabelWithAsterisk="Local de trabalho"
                            placeholder="Selecione um local de trabalho"
                            value={workspace.label} 
                            onChange={(selectedOption) => {
                                setWorkspace(selectedOption);
                            }}
                            options={workspaces.map(workspace => ({ value: workspace.value, label: workspace.label }))}
                            hasError={false}
                            errorInfo={''}
                        />

                        <InputV3
                            id="cargo"
                            type="select"
                            label="Cargo"
                            typeValueSelect='number'
                            floatingLabelWithAsterisk="Cargo"
                            placeholder="Selecione um cargo"
                            value={cargo.label}
                            onChange={(selectedOption) => {
                                setCargo(selectedOption);
                            }}
                            options={cargos.map(cargo => ({ value: cargo.value, label: cargo.label }))}
                            hasError={false}
                            errorInfo={''}
                        />

                        <InputV3
                            id="telefone"
                            type="telefone/celular"
                            label="Telefone/celular"
                            floatingLabelWithAsterisk="Telefone/Celular"
                            placeholder=""
                            value={telefone}
                            onChange={handleTelefoneChange}
                            hasError={hasTelefoneError}
                            onBlur={handleTelefoneBlur}
                            errorInfo={telefoneError}
                        />

                        <InputV3
                            id="receitas"
                            type="select"
                            label="Quantas receitas você emite por mês?"
                            typeValueSelect='string'
                            floatingLabelWithAsterisk="Quantas receitas você emite por mês?"
                            placeholder="Selecione a quantidade de receitas"
                            value={quantidadeReceitas.label}
                            onChange={(selectedOption) => {
                                setQuantidadeReceitas({
                                    value: selectedOption.value,
                                    label: selectedOption.label
                                });
                            }}
                            options={[
                                { value: "não", label: "Não emito receitas" },
                                { value: "1-10", label: "1 a 10" },
                                { value: "11-30", label: "11 a 30" },
                                { value: "31-50", label: "31 a 50" },
                                { value: "51-100", label: "51 a 100" },
                                { value: "+100", label: "Mais de 100" },
                            ]}
                            hasError={false}
                            errorInfo={''}
                        />
                    </S.ContainerInputs>

                    <S.ContainerButtonsAndTerms>
                        <S.ContainerButtons>
                            <S.ToGoBackButton
                                    type="button"
                                    onClick={handleGoToBack}
                                >
                                        <img src={SetaCinzaEsquerda} alt='Seta para esquerda ' />

                                        <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>Voltar</TaglineM>
                            </S.ToGoBackButton>

                            <S.SubmitButton
                                type="submit"
                                disabled={!isFormValid()}
                                onClick={handleContinuarClick}
                            >
                                {loading ? (
                                    <S.Loading disabled={loading}/>
                                ) : (
                                    <>
                                        <TaglineM fontWeight={800}>Entrar</TaglineM>

                                        <img src={isFormValid() ? SetaBranca : SetaCinzaDireita} alt='Seta para direita' />
                                    </>
                                )}
                            </S.SubmitButton>
                        </S.ContainerButtons>

                        <Auxiliar color={theme.colors.gray.Cinza_7} fontWeight={700}>
                            Ao continuar você concorda com a <br />

                            <label onClick={() => clickPolitica()}>Política de Privacidade </label>
                                e
                            <label onClick={() => clickTermos()}> Termos de Uso.</label>
                        </Auxiliar>
                    </S.ContainerButtonsAndTerms>
                </S.Form>
            );
        }
    };

    return (
        <S.Container>
            <S.Wrapper>
                <S.ContainerDescription>
                    <S.Description>
                        <img src={LogoBranca} alt='Logo AgroReceita Branco' />

                        <H3
                            color={theme.colors.white.Branco}
                            style={{
                                maxWidth: '400px',
                                width: '100%'
                            }}
                        >
                            {renderHeadingText()}
                        </H3>

                        <BodyG color={theme.colors.gray.Cinza_9}>{renderParagraphText()}</BodyG>
                        
                        {renderContainerImage()}
                    </S.Description>
                </S.ContainerDescription>

                <S.ContainerForm>
                    {renderFormMobile()}
                </S.ContainerForm>
            </S.Wrapper>

            <ModalTermos
                show={showTermos}
                btnOk={true}
                onHide={() => setShowTermos(false)}
            />

            <ModalPoliticas
                show={showPolitica}
                btnOk={true}
                onHide={() => setShowPolitica(false)}
            />
        </S.Container>
    );
};

export default withRouter(NovoCadastroCompleto);